export const brakeString = (str, cancel) => {
  return cancel ? str.replace(/\*/g, " ") : str.replace(/\*/g, "<br>");
};
